import React from 'react';
import { TableContainer, type TableContainerProps } from '@mui/material';
import { scrollableTableHostSx } from '../../constants/appShellLayout';

/**
 * Table host that scrolls horizontally on narrow viewports without expanding the page shell.
 * Use whenever a multi-column Table is not already inside a scrolling container.
 *
 * Accepts Paper props (`variant`, `elevation`, `square`) for the common
 * `component={Paper} variant="outlined"` call sites — MUI's polymorphic
 * TableContainer typing is lost once we wrap the component.
 */
export type ScrollableTableContainerProps = TableContainerProps & {
  variant?: 'elevation' | 'outlined';
  elevation?: number;
  square?: boolean;
};

const ScrollableTableContainer: React.FC<ScrollableTableContainerProps> = ({ sx, ...props }) => (
  <TableContainer
    {...(props as TableContainerProps)}
    sx={[
      scrollableTableHostSx,
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  />
);

export default ScrollableTableContainer;
